var React = require('react');

function ApplePodcast (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.237,0H4.189A4.194,4.194,0,0,0,0,4.189V16.237a4.194,4.194,0,0,0,4.189,4.189H16.237a4.194,4.194,0,0,0,4.189-4.189V4.189A4.194,4.194,0,0,0,16.237,0ZM12.309,13.585l-.37,2.959a1.2,1.2,0,0,1-1.188,1.048H9.673a1.2,1.2,0,0,1-1.188-1.048l-.37-2.959a2.113,2.113,0,0,1,2.1-2.375,1.8,1.8,0,1,1,1.8-1.8,1.8,1.8,0,0,1-1.8,1.8A2.113,2.113,0,0,1,12.309,13.585Zm-2.1-7.162A3.388,3.388,0,0,0,7.36,11.644,3.313,3.313,0,0,0,6.919,13a4.588,4.588,0,1,1,6.588,0,3.313,3.313,0,0,0-.442-1.359,3.388,3.388,0,0,0-2.852-5.221Zm2.986,9.7.184-1.474a5.785,5.785,0,1,0-6.339,0l.184,1.474a6.981,6.981,0,1,1,5.971,0Z","fill":"#383a36"}));
}

ApplePodcast.defaultProps = {"width":"20.425","height":"20.425","viewBox":"0 0 20.425 20.425"};

module.exports = ApplePodcast;

ApplePodcast.default = ApplePodcast;
